module.exports = __webpack_public_path__ + "img/intro01.eb959af5.png";